const buses = [{
  cName: 'Trailers and Buses',
  oSubMenu: [{
    cName: '53 Trailers Private Use over 500 lbs',
    cReturn: '53 Trailers Private Use over 500 lbs |t|t|t|t|t|t|t|t|t|t|t|t|t|t|t|1|t12|pt|2|1|53|53',
  }, // FS320.08(7)b changing 2 to 1 in third spot from end in pipe to allow specialty plates  to be chosen
  {
    cName: '36 Buses, 9 passenger and over, (All except private school bus)',
    cReturn: '36 Bus, 9 passenger and over, all types except private school bus|b|b|b|b|b|b|b|b|b|b|b|b|b|b|b|1|b12|pb|2|2|36|36',
  }, // FS320.08(7)b
  {
    cName: '36 Buses, 9 passenger and over,(All except private school bus) 6 month semiannual',
    cReturn: '36 Bus, 9 passenger and over, all types except private school bus, 6 month semiannual|s|s|s|s|s|s|s|s|s|s|s|s|s|s|s|1|2|ps|2|2|360|360',
  }, // FS320.08(7)b
  ],
}];

module.exports = buses;
